import React, { useEffect, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import { useTheme } from '../../../DataStore/ThemeContext';

const ManageStreams = ({ classInfo }) => {
    const { setDeleteStream, dispatch } = useConfig();
    const { openSettings } = useTheme();

    const handleEdit = (stream) => {
        openSettings("Edit Stream", "EditStream", stream);
    };

    const handleDelete = (stream) => {
        setDeleteStream({ show: true, stream: stream });
    };

    return (
        <div className='card'>
            <div className="card-body">
                <h5 className="mb-3">Manage Streams for {classInfo.class_name}</h5>
                <ul className="list-group mb-4">
                    {Array.isArray(classInfo.streams) && classInfo.streams.length > 0 ? (
                        classInfo.streams.map((item) => (
                            <li
                                className="list-group-item d-flex justify-content-between align-items-center"
                                key={item.stream_id}
                            >
                                <span>{item.stream_name}</span>
                                <div>
                                    <button
                                        className="btn btn-sm btn-outline-primary mr-2"
                                        onClick={() => handleEdit(item)}
                                    >
                                        <i className="fa fa-edit"></i> Edit
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDelete(item)}
                                    >
                                        <i className="fa fa-trash-alt"></i> Delete
                                    </button>
                                </div>
                            </li>
                        ))
                    ) : (
                        <li className="list-group-item text-muted">No streams available</li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default ManageStreams;
